import { Team } from "../teams/Team";

export class Match {

  id;
  isTournament;
  isPlayoff;
  isOneWay;
  homeTeam;
  awayTeam;
  score;
  championshipId;
  championshipSeason;

  constructor (match = {}) {
    this.id = match.id;
    this.isTournament = match.isTournament;
    this.isPlayoff = match.isPlayoff || false;
    this.isOneWay = match.isOneWay || false;
    this.homeTeam = new Team(match.homeTeam);
    this.awayTeam = new Team(match.awayTeam);
    this.score = match.score;
    this.championshipId = match.championshipId;
    this.championshipSeason = match.championshipSeason;
  }

}